import { AutogenLayoutBank } from "./autogen/AutogenLayoutBank";
import { DataHeader } from "@mcleod/components";
import { DuplicateId, DuplicateIdProps } from "@mcleod/dispatch";

const DUPLICATE_VALIDATION_PROPS: DuplicateIdProps = {
    tableName: "bank",
    screenName: "Banks",
    navigateToUrl: "lme/settlement/Bank?mode=update&key="
};

export class Bank extends AutogenLayoutBank {
    onLoad(): void | Promise<void> {
        DuplicateId.configureIdTextbox(this.textboxId, DUPLICATE_VALIDATION_PROPS);
    }

    public override doAfterDataHeaderSetup(dataHeader: DataHeader): void {
        dataHeader.showDelete = true;
    }
}
